import React from 'react';
import request from 'axios';
import { Link } from 'react-router';
import { SubmissionError } from 'redux-form';
import { browserHistory } from 'react-router';
import { isMobile } from 'common/utils';
import { ADMIN_ROOT } from 'common/variables';
import { getWatchableCategories } from 'common/ducks/categories';
import cookie from 'react-cookie';
import idx from 'idx';
import union from 'lodash/union';
import without from 'lodash/without';
import reduce from 'lodash/reduce';
import difference from 'lodash/difference';
import { setBannerError } from 'error';
import { FORBIDDEN_INACTIVE_CODE } from 'account/constants';
import { REFERRER_COOKIE_NAME } from 'marketing/constants';
import { setGoogleDimension } from 'common/tracking';
import { toggleAgencyQuestion } from 'pap/ducks/workflow';

/* ACTIONS
================================================================================================ */
const GET_USER_DATA = 'crowdspring/user/GET_USER_DATA';
const GET_USER_DATA_REQUEST = 'crowdspring/user/GET_USER_DATA_REQUEST';
export const GET_USER_DATA_SUCCESS = 'crowdspring/user/GET_USER_DATA_SUCCESS';
const GET_USER_DATA_FAILURE = 'crowdspring/user/GET_USER_DATA_FAILURE';

const UPDATE_USER = 'crowdspring/user/UPDATE_USER';
const UPDATE_USER_SUCCESS = 'crowdspring/user/UPDATE_USER_SUCCESS';
const UPDATE_USER_FAILURE = 'crowdspring/user/UPDATE_USER_FAILURE';

const USER_LOGIN_REQUEST = 'crowdspring/user/USER_LOGIN_REQUEST';
const USER_LOGIN_SUCCESS = 'crowdspring/user/USER_LOGIN_SUCCESS';
const USER_LOGIN_FAILURE = 'crowdspring/user/USER_LOGIN_FAILURE';

const VERIFY_EMAIL = 'crowdspring/user/VERIFY_EMAIL';
const VERIFY_EMAIL_SUCCESS = 'crowdspring/user/VERIFY_EMAIL_SUCCESS';
const VERIFY_EMAIL_FAILURE = 'crowdspring/user/VERIFY_EMAIL_FAILURE';

const FETCH_LEAD_SOURCES = 'crowdspring/user/FETCH_LEAD_SOURCES';
const FETCH_LEAD_SOURCES_SUCCESS = 'crowdspring/user/FETCH_LEAD_SOURCES_SUCCESS';

const FETCH_TIMEZONES = 'crowdspring/user/FETCH_TIMEZONES';
const FETCH_TIMEZONES_SUCCESS = 'crowdspring/user/FETCH_TIMEZONES_SUCCESS';

const FETCH_COUNTRIES = 'crowdspring/user/FETCH_COUNTRIES';
const FETCH_COUNTRIES_SUCCESS = 'crowdspring/user/FETCH_COUNTRIES_SUCCESS';

const UPDATE_MOBILE = 'crowdspring/user/UPDATE_MOBILE';
const UPDATE_MOBILE_REQUEST = 'crowdspring/user/UPDATE_MOBILE_REQUEST';
const UPDATE_MOBILE_SUCCESS = 'crowdspring/user/UPDATE_MOBILE_SUCCESS';
const UPDATE_MOBILE_FAILURE = 'crowdspring/user/UPDATE_MOBILE_FAILURE';

const UPDATE_MOBILE_SMART = 'crowdspring/user/UPDATE_MOBILE_SMART';
const UPDATE_MOBILE_SMART_REQUEST = 'crowdspring/user/UPDATE_MOBILE_SMART_REQUEST';
const UPDATE_MOBILE_SMART_SUCCESS = 'crowdspring/user/UPDATE_MOBILE_SMART_SUCCESS';
const UPDATE_MOBILE_SMART_FAILURE = 'crowdspring/user/UPDATE_MOBILE_SMART_FAILURE';

const VERIFY_MOBILE_BY_CODE = 'crowdspring/user/VERIFY_MOBILE_BY_CODE';
const VERIFY_MOBILE_BY_CODE_REQUEST = 'crowdspring/user/VERIFY_MOBILE_BY_CODE_REQUEST';
const VERIFY_MOBILE_BY_CODE_SUCCESS = 'crowdspring/user/VERIFY_MOBILE_BY_CODE_SUCCESS';
const VERIFY_MOBILE_BY_CODE_FAILURE = 'crowdspring/user/VERIFY_MOBILE_BY_CODE_FAILURE';

const VERIFY_MOBILE_BY_LINK = 'crowdspring/user/VERIFY_MOBILE_BY_LINK';
const VERIFY_MOBILE_BY_LINK_REQUEST = 'crowdspring/user/VERIFY_MOBILE_BY_LINK_REQUEST';
const VERIFY_MOBILE_BY_LINK_SUCCESS = 'crowdspring/user/VERIFY_MOBILE_BY_LINK_SUCCESS';
const VERIFY_MOBILE_BY_LINK_FAILURE = 'crowdspring/user/VERIFY_MOBILE_BY_LINK_FAILURE';

const RESEND_VALIDATION_EMAIL = 'crowdspring/user/RESEND_VALIDATION_EMAIL';
const RESEND_VALIDATION_EMAIL_SUCCESS = 'crowdspring/user/RESEND_VALIDATION_EMAIL_SUCCESS';

const WATCH_SUB_CATEGORY = 'crowdspring/user/WATCH_SUB_CATEGORY';
const UNWATCH_SUB_CATEGORY = 'crowdspring/user/UNWATCH_SUB_CATEGORY';
const WATCH_SUB_CATEGORY_ONSITE = 'crowdspring/user/WATCH_SUB_CATEGORY_ONSITE';
const UNWATCH_SUB_CATEGORY_ONSITE = 'crowdspring/user/UNWATCH_SUB_CATEGORY_ONSITE';

const CANCEL_PHONE_VERIFICATION = 'crowdspring/user/CANCEL_PHONE_VERIFICATION';

const FETCH_IP_INFO = 'crowdspring/user/FETCH_IP_INFO';
const FETCH_IP_INFO_SUCCESS = 'crowdspring/user/FETCH_IP_INFO_SUCCESS';

const FETCH_CHAT_PERMISSIONS = 'user/FETCH_CHAT_PERMISSIONS';
const FETCH_CHAT_PERMISSIONS_SUCCESS = 'user/FETCH_CHAT_PERMISSIONS_SUCCESS';

const FETCH_LANGUAGES = 'user/FETCH_LANGUAGES';
const FETCH_LANGUAGES_SUCCESS = 'user/FETCH_LANGUAGES_SUCCESS';

const initialState = {
  logged_in: false,
  profile_data: {},
  email: '',
  leadSources: [],
  timezones: [],
  countries: [],
};

/* HELPERS
================================================================================================ */
export const profileDefaults = {
  user_timezone: 'US/Central',
  receive_communication: true,
  country: 'us'
};
export const createUserRequest = formData => {
  const referrer = cookie.load(REFERRER_COOKIE_NAME);

  const promise = request.post('/api/v1/users/', {
    ...formData,
    referrer: referrer? atob(referrer) : undefined
  });

  if (referrer) {
    promise.then(() => cookie.remove(REFERRER_COOKIE_NAME, { path: '/' }));
  }

  return promise;
}
export const updateUserRequest = (userId, formData) => (
  request.patch(`/api/v1/users/${userId}/`, formData)
);
export const setPasswordRequest = (userId, formData) => (
  request.patch(`/api/v1/users/${userId}/set_password/`, formData)
);
export const removeAccountRequest = (userId) => (
  request.delete(`/api/v1/users/${userId}/`)
);
export const sendPwdResetLinkRequest = (formData) => (
  request.patch('/api/v1/users/reset_password_request/', formData)
);
export const resetPasswordRequest = (formData) => (
  request.post('/api/v1/reset-password/', formData)
);

export const createRegistrationWaiterRequest = formData => (
  request.post('/api/v1/creative-registration-waiters/', formData)
);

const watchSubcategoryRequest = (subcatId, frequency, dispatch) => {
  return request.get(`/api/v1/project-subcategories/${subcatId}/watch_${frequency}/`)
    .catch(() => {
      dispatch(setBannerError('Error watching subcategory', 'Please try again'));
    })
}

const unwatchSubcategoryRequest = (subcatId, dispatch) => {
  return request.get(`/api/v1/project-subcategories/${subcatId}/unwatch_email/`)
    .catch(() => {
      dispatch(setBannerError('Error unwatching subcategory', 'Please try again'));
    })
}

const watchSubcategoryOnsiteRequest = (subcatId, dispatch) => {
  return request.get(`/api/v1/project-subcategories/${subcatId}/watch_onsite/`)
    .catch(() => {
      dispatch(setBannerError('Error watching subcategory', 'Please try again'));
    })
}

const unwatchSubcategoryOnsiteRequest = (subcatId, dispatch) => {
  return request.get(`/api/v1/project-subcategories/${subcatId}/unwatch_onsite/`)
    .catch(() => {
      dispatch(setBannerError('Error unwatching subcategory', 'Please try again'));
    })
}

/* Return modified profile data with updated sub-category watchlists. */
export const updateSubcatWatchlists = (onsite, action, profile, subcatId, frequency) => {
  let watchlist, otherWatchlist;

  /* if onsite, just add or remove to/from its watchlist depending on the action */
  if (onsite) {
    watchlist = 'watchlist_subcat_ids_onsite';
    if (action === 'unwatch') {
      profile[watchlist] = without(profile[watchlist], subcatId);
    } else {
      profile[watchlist] = union(profile[watchlist], [subcatId]);
    }

  /* otherwise, add or remove to/from respective watchlists depending on the action and
   * frequency */
  } else {
    if (action === 'watch') {
      watchlist = `watchlist_subcat_ids_${frequency}`;
      if (frequency === 'immediate') {
        otherWatchlist = 'watchlist_subcat_ids_digest';
      } else {
        otherWatchlist = 'watchlist_subcat_ids_immediate';
      }
      profile[watchlist] = union(profile[watchlist], [subcatId]);
      profile[otherWatchlist] = without(profile[otherWatchlist], subcatId);

    } else {
      watchlist = 'watchlist_subcat_ids_digest';
      otherWatchlist = 'watchlist_subcat_ids_immediate';
      profile[watchlist] = without(profile[watchlist], subcatId);
      profile[otherWatchlist] = without(profile[otherWatchlist], subcatId);
    }
  }

  return { ...profile };
}

export const fetchEliteWarningsRequest = id => request.get(`/api/v1/users/${id}/elite_warnings/`);

/* convert choices retrieved from the backend into the format used in the frontend */
export const formatChoices = payload => payload.map(c => ({
  field: c[0],
  label: c[1],
  group: c[2] === true? 'Most used' : (c[2] === false? 'Others' : undefined)
}));

function shouldCreateUser(state) {
  // No data and we're not already fetching
  if (!state.user.logged_in && !state.user.isFetching) {
    return true;
  }

  return false;
}

export const logout = (redirectTo, resumeLastUrl) => (dispatch, getState) => {
  request.get('/api/v1/logout/').then(() => {
    cookie.remove('sessionid');
    cookie.remove('csrftoken');

    dispatch({
      type: 'USER_DATA_REMOVED',
      data: null
    });

    if (resumeLastUrl) {
      const lastUrl = getState().routing.locationBeforeTransitions.pathname;
      browserHistory.push(`/login/?resuming=true&next=${lastUrl}`);
    } else {
      browserHistory.push(redirectTo || '/login/');
    }
  }).catch((response) => {
    dispatch({
      type: 'USER_LOGOUT_FAILED',
      response
    });
  })
}

const formatLanguages = (data) => {
  const list = data.map((language) => ({ label: language[1], value: language[0] }));
  const abbreviations = data.reduce((mem, language) => {
    mem[language[0]] = language[1];
    return mem
  }, {});

  return {
    list,
    abbreviations,
  };
}

/* REDUCERS
 ================================================================================================ */

export default function reducer(state = initialState, action) {
  let profile = null
  let subcatId, frequency;

  switch (action.type) {
    case GET_USER_DATA_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case GET_USER_DATA_SUCCESS:
      profile = { ...action.data };

      profile.user_type = profile.is_client ? 'client' : 'creative';

      return {
        ...state,
        isFetching: false,
        profile_data: profile,
        logged_in: true,
      };
    case GET_USER_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    case 'USER_DATA_REMOVED':
      return Object.assign({}, state, {
        isFetching: false,
        profile_data: {},
        logged_in: false
      });
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        error: action.error.data
      }
    case UPDATE_USER_SUCCESS:
      profile = { ...action.payload };
      return {
        ...state,
        profile_data: profile,
        error: null
      }
    case VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        profile_data: {...state.profile_data, is_email_validated: true},
        emailVerified: true
      };
    case VERIFY_EMAIL_FAILURE:
      return {
        ...state,
        emailVerified: false,
      };
    case FETCH_LEAD_SOURCES_SUCCESS:
      return {
        ...state,
        leadSources: formatChoices(action.payload)
      };
    case FETCH_TIMEZONES_SUCCESS:
      return {
        ...state,
        timezones: formatChoices(action.payload)
      };
    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: formatChoices(action.payload)
      };
    case UPDATE_MOBILE_REQUEST:
    case UPDATE_MOBILE_SMART_REQUEST:
      return {
        ...state,
        mobileUpdatedSmart: false,
        mobileUpdated: false,
        updatingMobile: true,
        error: null,
      };
    case UPDATE_MOBILE_SUCCESS:
      return {
        ...state,
        updatingMobile: false,
        mobileUpdated: true,
        error: null,
        profile_data: {...state.profile_data, mobile_number: action.payload.mobile_number}
      };
    case UPDATE_MOBILE_FAILURE:
    case UPDATE_MOBILE_SMART_FAILURE:
      return {
        ...state,
        updatingMobile: false,
        error: (
          idx(action, _ => _.error.data.mobile_number) ||
          "Failed to update mobile number. Please try again."
        ),
      };
    case UPDATE_MOBILE_SMART_SUCCESS:
      return {
        ...state,
        updatingMobile: false,
        mobileUpdatedSmart: true,
        error: null,
        profile_data: {...state.profile_data, mobile_number: action.payload.mobile_number}
      };
    case VERIFY_MOBILE_BY_CODE_REQUEST:
    case VERIFY_MOBILE_BY_LINK_REQUEST:
      return {
        ...state,
        verifyingMobile: true,
        error: null,
      };
    case VERIFY_MOBILE_BY_CODE_SUCCESS:
    case VERIFY_MOBILE_BY_LINK_SUCCESS:
      return {
        ...state,
        verifyingMobile: false,
        mobileValidated: true,
        error: null,
      };
    case VERIFY_MOBILE_BY_CODE_FAILURE:
    case VERIFY_MOBILE_BY_LINK_FAILURE:
      return {
        ...state,
        verifyingMobile: false,
        mobileValidated: false,
        error: "Invalid code. Please try again.",
      };
    case RESEND_VALIDATION_EMAIL_SUCCESS:
      return {
        ...state,
        validationEmailResent: true,
      };
    case WATCH_SUB_CATEGORY:
      profile = { ...state.profile_data };
      ({ subcatId, frequency } = action.payload);
      return {
        ...state,
        profile_data: updateSubcatWatchlists(false, 'watch', profile, subcatId, frequency)
      };
    case UNWATCH_SUB_CATEGORY:
      profile = { ...state.profile_data };
      ({ subcatId } = action.payload);
      return {
        ...state,
        profile_data: updateSubcatWatchlists(false, 'unwatch', profile, subcatId)
      };
    case WATCH_SUB_CATEGORY_ONSITE:
      profile = { ...state.profile_data };
      ({ subcatId } = action.payload);
      return {
        ...state,
        profile_data: updateSubcatWatchlists(true, 'watch', profile, subcatId)
      };
    case UNWATCH_SUB_CATEGORY_ONSITE:
      profile = { ...state.profile_data };
      ({ subcatId } = action.payload);
      return {
        ...state,
        profile_data: updateSubcatWatchlists(true, 'unwatch', profile, subcatId)
      };
    case CANCEL_PHONE_VERIFICATION:
      return {
        ...state,
        mobileUpdatedSmart: false
      };
    case FETCH_IP_INFO_SUCCESS:
      return {
        ...state,
        ipInfo: action.payload
      };
    case FETCH_CHAT_PERMISSIONS_SUCCESS:
      return {
        ...state,
        canChat: action.payload
      };
    case FETCH_LANGUAGES_SUCCESS:
      return {
        ...state,
        languages: formatLanguages(action.payload)
      };
    default:
      return state;
  }
}

/* ACTION CREATORS
 ================================================================================================ */

/* Update user locally */
export const updateUserLocal = (data) => (dispatch) => (
  dispatch({
    type: GET_USER_DATA_SUCCESS,
    data
  })
);

export const createUser = email => (
  {
    type: GET_USER_DATA,
    promise: createUserRequest({ is_client: true, email })
  }
);

export const createUserIfNeeded = (email) => (dispatch, getState) => {
  const state = getState();

  if (shouldCreateUser(state)) {
    return dispatch(createUser(email));
  }

  return Promise.resolve(state.user.data);
};

export const verifyEmail = (base64, hex32, registering) => (dispatch) => {
  const promise = request.get(`/api/v1/verify/${base64}/${hex32}/`);
  promise.then((data) => {
    /* continue registration if that's the case */
    if (registering) {
      browserHistory.push('/register/continue/');
    }
  });

  return dispatch({
    type: VERIFY_EMAIL,
    promise
  });
};

/* Re-send email validation email. */
export const resendValidationEmail = () => (dispatch, getState) => {
  const userId = getState().user.profile_data.id
  return dispatch({
    type: RESEND_VALIDATION_EMAIL,
    promise: request.put(`/api/v1/users/${userId}/resend_validation_email/`)
  });
};

/* Validate SMS code to confirm user's mobile phone. */
export const verifyPhoneByCode = code => dispatch => (
  dispatch({
    type: VERIFY_MOBILE_BY_CODE,
    promise: request.post('/api/v1/verify/mobile/', { code })
  })
);

/* Validate SMS magic link to confirm user's mobile phone. */
export const verifyPhoneByLink = (base64, hex32) => (dispatch) => {
  const promise = request.get(`/api/v1/verify/mobile/${base64}/${hex32}/`);

  promise.then(() => {
    /* Right now, we only validate user's phone during registration,
       so continue the process from where it left. */

    cookie.save('resume_registration_from_magic_link', true, { path: '/' });

    /* We don't want to use browserHistory.push() or similar here, because user may have
       been just logged in, so this forces a full reload on the page with a clean
       and consistent state. */
    window.location.href = '/register/continue';
  });

  return dispatch({
    type: VERIFY_MOBILE_BY_LINK,
    promise,
  });
};


/* Update user's mobile phone, which will trigger a subsequent validation via SMS
   (either a code or a link (if smart is true)). */
export const updateMobilePhone = (phone, smart, onSuccess) => (dispatch, getState) => {
  const userId = getState().user.profile_data.id

  /* If smart mode is used, store whether the update is being done on mobile, so
     that it can be used afterwards. */
  if (smart) {
    cookie.save('magic_link_sent_from_mobile', isMobile(), {path: '/'})
  }

  const promise = request.patch(`/api/v1/users/${userId}/set_mobile/` +
                    (smart? "?smart=true":""), {mobile_number: phone})

  promise.then(onSuccess)

  return dispatch({
    type: smart? UPDATE_MOBILE_SMART:UPDATE_MOBILE,
    promise: promise
  });
};

export const resendPhoneVerification = (smart) => (dispatch, getState) => {
  const userId = getState().user.profile_data.id
  const phone = getState().user.profile_data.mobile_number;
  return request.patch(
    `/api/v1/users/${userId}/set-mobile/` + (smart? "?smart=true":""), {mobile_number: phone}
  );
}

export const cancelPhoneVerification = () => {
  return {
    type: CANCEL_PHONE_VERIFICATION
  };
}

export const login = (identification, password, next) => (dispatch) => {
  dispatch({
    type: USER_LOGIN_REQUEST,
  });

  return request.post('/api/v1/login/', {
    identification,
    password,
  })
  .then((response) => {
    // Reset the CSRF token for all requests after login
    /* @TODO: probably this is not needed anymore since we are adding the header on the fly */
    request.defaults.headers.common['X-CSRFToken'] = cookie.load('csrftoken');

    if (response.data.user_converted_from) {
      // dimension1 = user_converted_from (defined in analytics)
      try {
        setGoogleDimension('dimension1', response.data.user_converted_from);
      } catch (e) {
        console.error(e);
      }
    }

    dispatch({
      type: USER_LOGIN_SUCCESS,
    });
    dispatch({
      type: GET_USER_DATA_SUCCESS,
      data: response.data,
    });

    /* (un)toggle agency question if logging in from PAP */
    dispatch(toggleAgencyQuestion(!idx(response, _ => _.data.is_agency_question_answered)));

    /* redirect user to appropriate URL */
    if (next === null) {
      return;
    }
    let redirectTo = '/your-projects/';
    if (next) { redirectTo = next; }
    else if (idx(response, _ => _.data.is_staff)) { redirectTo = ADMIN_ROOT; }
    browserHistory.push(redirectTo);

  }).catch((err) => {
    /* show appropriate banner if user is inactive */
    if (idx(err, _ => _.data.error_code) === FORBIDDEN_INACTIVE_CODE) {
      dispatch(showInactiveBanner());
      return;
    }

    dispatch({
      type: USER_LOGIN_FAILURE,
    });
    throw new SubmissionError({
      _error: (
        err.status === 429?
        "Too many login attempts. Please try again in a minute." :
        "Whoops! Invalid credentials. Please try again."
      )
    });
  });
};

export const fetchLeadSourcesIfNeeded = () => (dispatch, getState) => {
  const state = getState();

  if (state.user.leadSources.length === 0) {
    return dispatch({
      type: FETCH_LEAD_SOURCES,
      promise: request({ method: 'get', url: '/api/v1/users/lead_sources/' })
    });
  }

  return Promise.resolve();
}

export const fetchTimezonesIfNeeded = () => (dispatch, getState) => {
  const state = getState();

  if (state.user.timezones.length === 0) {
    return dispatch({
      type: FETCH_TIMEZONES,
      promise: request({ method: 'get', url: '/api/v1/users/timezones/' })
    });
  }

  return Promise.resolve();
};

export const fetchCountriesIfNeeded = () => (dispatch, getState) => {
  const state = getState();

  if (state.user.countries.length === 0) {
    return dispatch({
      type: FETCH_COUNTRIES,
      promise: request({ method: 'get', url: '/api/v1/users/countries/' }),
    });
  }

  return Promise.resolve();
};

export const updateUser = (data) => (dispatch) => {
  const promise = updateUserRequest(data['id'], data);

  dispatch({
    type: UPDATE_USER,
    promise
  });

  return promise;
};

export const fetchCurrentUser = () => (dispatch) => {
  request.get('/api/v1/users/current/').then(({ data }) => {
    dispatch({
      type: GET_USER_DATA_SUCCESS,
      data
    });
  });
};

/* Watch(email) a specific sub-category with a given frequency. */
export const watchSubcategory = (subcatId, frequency) => (dispatch) => {
  dispatch({
    type: WATCH_SUB_CATEGORY,
    payload: { subcatId, frequency },
  });
  return watchSubcategoryRequest(subcatId, frequency, dispatch);
}

/* Unwatch(email) a specific sub-category. */
export const unwatchSubcategory = (subcatId) => (dispatch) => {
  dispatch({
    type: UNWATCH_SUB_CATEGORY,
    payload: { subcatId },
  });
  return unwatchSubcategoryRequest(subcatId, dispatch);
}

/* Watch(email) a specific category with a given frequency. */
export const watchCategory = (cat, frequency) => (dispatch) => {
  reduce(cat.subcategories, (acc, subcat) => {
    dispatch({
      type: WATCH_SUB_CATEGORY,
      payload: { subcatId: subcat.id, frequency }
    });

    /* make requests sequentially to avoid race conditions */
    return acc.then(_ => watchSubcategoryRequest(subcat.id, frequency, dispatch));
  }, Promise.resolve());
}

/* Unwatch(email) a specific category. */
export const unwatchCategory = (cat) => (dispatch) => {
  reduce(cat.subcategories, (acc, subcat) => {
    dispatch({
      type: UNWATCH_SUB_CATEGORY,
      payload: { subcatId: subcat.id }
    });

    /* make requests sequentially to avoid race conditions */
    return acc.then(_ => unwatchSubcategoryRequest(subcat.id, dispatch));
  }, Promise.resolve());
}

/* Unwatch(email) all categories. */
export const unwatchAllCategories = () => (dispatch, getState) => {
  const cats = getWatchableCategories(getState().categories.data);
  cats.forEach(cat => {
    cat.subcategories.forEach(subcat => {
      dispatch({
        type: UNWATCH_SUB_CATEGORY,
        payload: { subcatId: subcat.id }
      });
    });
  });

  return request.get('/api/v1/project-subcategories/unwatch_email_all/')
    .catch(() => {
      dispatch(setBannerError('Error unwatching all subcategories', 'Please try again'));
    })
}

/* Watch(onsite) a specific sub-category. */
export const watchSubcategoryOnsite = (subcatId) => (dispatch) => {
  dispatch({
    type: WATCH_SUB_CATEGORY_ONSITE,
    payload: { subcatId },
  });
  return watchSubcategoryOnsiteRequest(subcatId, dispatch);
}

/* Unwatch(onsite) a specific sub-category. */
export const unwatchSubcategoryOnsite = (subcatId) => (dispatch) => {
  dispatch({
    type: UNWATCH_SUB_CATEGORY_ONSITE,
    payload: { subcatId },
  });
  return unwatchSubcategoryOnsiteRequest(subcatId, dispatch);
}

/* Watch(onsite) a specific category. */
export const watchCategoryOnsite = (cat) => (dispatch) => {
  reduce(cat.subcategories, (acc, subcat) => {
    dispatch({
      type: WATCH_SUB_CATEGORY_ONSITE,
      payload: { subcatId: subcat.id }
    });

    /* make requests sequentially to avoid race conditions */
    return acc.then(_ => watchSubcategoryOnsiteRequest(subcat.id, dispatch));
  }, Promise.resolve());
}

/* Unwatch(onsite) a specific category. */
export const unwatchCategoryOnsite = (cat) => (dispatch) => {
  reduce(cat.subcategories, (acc, subcat) => {
    dispatch({
      type: UNWATCH_SUB_CATEGORY_ONSITE,
      payload: { subcatId: subcat.id }
    });

    /* make requests sequentially to avoid race conditions */
    return acc.then(_ => unwatchSubcategoryOnsiteRequest(subcat.id, dispatch));
  }, Promise.resolve());
}

export const showInactiveBanner = () => (dispatch) => {
  const content = (
    <p>
      It looks like your account is inactive. You won't be able to log in or
      reset your password until you <Link to="/help/contact/">contact our support team</Link>.
    </p>
  );
  dispatch(setBannerError('Action Required', content));
}

export const setAgencySegment = (isAgency) => (dispatch, getState) => {
  const profileData = getState().user.profile_data;
  const currentSegments = profileData.marketing_segments || [];

  /* assure that segments obbey the business rules enforced by the backend */
  let updatedSegments = [...currentSegments];

  /* "agency", "top_n_companies" and "business_owner" are mutually exclusive */
  if (isAgency) {
    updatedSegments = ["agency"].concat(
      without(currentSegments, "agency", "top_n_companies", "business_owner")
    );
  } else if (currentSegments.includes("agency")) {
    updatedSegments = ["business_owner"].concat(without(currentSegments, "business_owner", "agency"))
  }

  const toAdd = difference(updatedSegments, currentSegments);
  const toRemove = difference(currentSegments, updatedSegments);

  if (toAdd.length === 0 && toRemove.length === 0 && profileData.is_agency_question_answered) {
    return Promise.resolve();
  }

  /* removal has to take place before new segments are added to avoid validation errors */
  let premises = toRemove.reduce((acc, segment) => (
    acc.then(() => request.patch(`/api/v1/users/${profileData.id}/remove_marketing_segment/`, {
      marketing_segment: segment
    }))
  ), Promise.resolve());
  premises = toAdd.reduce((acc, segment) => (
    acc.then(() => request.patch(`/api/v1/users/${profileData.id}/add_marketing_segment/`, {
      marketing_segment: segment
    }))
  ), premises);

  premises.then(() => dispatch(
    updateUser({ id: profileData.id, is_agency_question_answered: true })
  ));

  return premises;
}

export const fetchIpInfoIfNeeded = () => (dispatch, getState) => {
  const { ipInfo } = getState().user;

  if (ipInfo) {
    return Promise.resolve({ data: ipInfo });
  }

  const promise = request.get("/api/v1/users/ip_info/");

  dispatch({
    type: FETCH_IP_INFO,
    promise
  });

  return promise;
};

export const fetchChatPermsIfNeeded = () => (dispatch, getState) => {
  const state = getState();

  if (state.user.canChat === undefined) {
    return dispatch({
      type: FETCH_CHAT_PERMISSIONS,
      promise: request.get("/api/v1/users/can_chat/")
    });
  }

  return Promise.resolve();
};

export const fetchLanguagesIfNeeded = () => (dispatch, getState) => {
  const state = getState();

  if (!state.user.languages) {
    return dispatch({
      type: FETCH_LANGUAGES,
      promise: request.get("/api/v1/users/languages/"),
    });
  }

  return Promise.resolve();
};
